import { loadCookie } from '#src/lib/cookies.ts';
import { xsrfCookieName } from '#src/lib/http.ts';

export const AuthenticityToken = () => {
  return (
    <input
      type="hidden"
      name="authenticity_token"
      value={loadCookie(xsrfCookieName)}
    />
  );
};
